import { useSetupState } from './use-setup-state'

/** Messages and Notifications exist for every scope, but staff reach them at
 *  /super/* so page views split by path without a property breakdown. both
 *  trees render the same pages; this is the one place that picks the base. */
export function useScopePrefix(): '' | '/super' {
  return useSetupState().setupState?.scope === 'super' ? '/super' : ''
}
